/** `documentFormat` for the upload endpoints: the lower-cased extension (`pdf`, `docx`), or `unknown`. */
export const getDocumentFormat = (fileName: string): string => {
  const dotIndex = fileName.lastIndexOf('.');

  // `<= 0` also covers dotfiles: the leading dot of `.gitignore` names the file, not a format.
  if (dotIndex <= 0) return 'unknown';

  return fileName.slice(dotIndex + 1).toLowerCase() || 'unknown';
};

/** Byte size as the `documentSizeMb` the upload endpoints expect. */
export const toDocumentSizeMb = (bytes: number): number => bytes / (1024 * 1024);
